/**
 * TKT #274563 · Stable per-install device id. CLIENT-SUPPLIED IDENTIFICATION
 * ONLY — never authentication. The server uses it solely to scope logout
 * invalidation / audit of Google attempts; it never grants access and is never
 * trusted as proof of identity. Signed-out attempts (no user_id) are scoped by
 * this id so a later logout on the same device can invalidate them.
 */
const K_DEVICE_ID = "cc.device.id";

function _rand() {
  try {
    const a = new Uint8Array(16);
    (window.crypto || window.msCrypto).getRandomValues(a);
    return Array.from(a, (b) => b.toString(16).padStart(2, "0")).join("");
  } catch {
    return String(Date.now()) + Math.random().toString(16).slice(2);
  }
}

export function getDeviceId() {
  try {
    let id = window.localStorage.getItem(K_DEVICE_ID);
    if (!id) { id = _rand(); window.localStorage.setItem(K_DEVICE_ID, id); }
    return id;
  } catch {
    return _rand(); // storage unavailable — ephemeral id; still not auth
  }
}
